import { render, staticRenderFns } from "./EbookHome.vue?vue&type=template&id=756c351a&scoped=true"
import script from "./EbookHome.vue?vue&type=script&lang=js"
export * from "./EbookHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c351a",
  null
  
)

export default component.exports